import { render, staticRenderFns } from "./WelcomeScreenPage.vue?vue&type=template&id=9580de1e&scoped=true&"
import script from "./WelcomeScreenPage.vue?vue&type=script&lang=ts&"
export * from "./WelcomeScreenPage.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeScreenPage.vue?vue&type=style&index=0&id=9580de1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9580de1e",
  null
  
)

export default component.exports